import { LoadingStatusEnum } from '../../../constants/enums';

const initialState = {
  list: [],
  summaries: [],
  loading: LoadingStatusEnum.Idle,
  mutationLoading: LoadingStatusEnum.Idle,
};

export default initialState;
